import React, { useEffect } from "react";
import Footer from "@/components/Footer";
import Logo from "@/assets/logo.png";
import { IconNotification } from "@arco-design/web-react/icon";
import LoginForm from "./form";
import LoginBanner from "./banner";
import styles from "./style/index.module.less";

function Login() {
  useEffect(() => {
    document.body.setAttribute("arco-theme", "light");
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        {/* <Logo /> */}
        <img
          src={Logo}
          alt="logo"
          width={20}
          height={20}
          className={styles["logo-img"]}
        />
        <div className={styles["logo-text"]}>后台管理系统</div>
      </div>
      <div className={styles.banner}>
        <div className={styles["banner-inner"]}>
          <LoginBanner />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles["login-notice"]}>
          <span className={styles["login-notice-label"]}>
            <IconNotification />
            公告
          </span>
          <span className={styles["login-notice-content"]}>
            有问题联系客服: 抖音号41005956098 飞机号+1 645 233 0388
            QQ号203399736
          </span>
        </div>
        <div className={styles["content-inner"]}>
          <LoginForm />
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
Login.displayName = "LoginPage";

export default Login;
